/** START : PRODUCT SLIDER **************************************************/
const bannerSection = document.querySelector("#banner");
const panelSection = document.querySelector("#product-panel");

// Initialize each Swiper with scoped navigation elements
const bannerSwiper = new Swiper("#banner .bannerMain", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0
});

const panelSwiper = new Swiper("#product-panel .bannerMain", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0
});

// Thumbnail nodes per section
const bannerThumbs = bannerSection.querySelectorAll(".banner-gallery .banner-slide");
const panelThumbs = panelSection.querySelectorAll(".banner-gallery .banner-slide");

function updateBannerThumbs(activeIndex) {
  bannerThumbs.forEach(el => el.classList.remove("active"));
  if (bannerThumbs[activeIndex]) bannerThumbs[activeIndex].classList.add("active");
}

function updatePanelThumbs(activeIndex) {
  panelThumbs.forEach(el => el.classList.remove("active"));
  if (panelThumbs[activeIndex]) panelThumbs[activeIndex].classList.add("active");
}

// Keep thumbs in each section in sync with its own slider only
bannerSwiper.on('slideChange', () => {
  const idx = bannerSwiper.realIndex;
  updateBannerThumbs(idx);
});

panelSwiper.on('slideChange', () => {
  const idx = panelSwiper.realIndex;
  updatePanelThumbs(idx);
});

// Clicking thumbs controls only its own slider
bannerThumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => {
    bannerSwiper.slideToLoop(index);
    updateBannerThumbs(index);
  });
});

panelThumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => {
    panelSwiper.slideToLoop(index);
    updatePanelThumbs(index);
  });
});
/** END : PRODUCT SLIDER **************************************************/


/** START: COUNTDOWN ************************************************/
const startCountdown = (durationInSeconds) => {
    const timerElement = document.querySelector("[data-timer]");

    let remainingTime = durationInSeconds;

    const updateTimerDisplay = () => {
        const hours = Math.floor(remainingTime / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((remainingTime % 3600) / 60).toString().padStart(2, '0');
        const seconds = (remainingTime % 60).toString().padStart(2, '0');

        timerElement.textContent = `${hours}h : ${minutes}min : ${seconds}sec`;

        if (remainingTime > 0) {
            remainingTime--;
        } else {
            clearInterval(timerInterval);
            timerElement.textContent = "Time's up!";
        }
    }

    updateTimerDisplay();
    const timerInterval = setInterval(updateTimerDisplay, 1000);
}
startCountdown(22049);
/** END: COUNTDOWN **************************************************/


/** START: SUPPLEMENT FACTS POPUP MODAL *********************************/
// Get all supplement modal buttons
const supplementModalButtons = document.querySelectorAll("[data-modal='supplement']");

// Add click event listeners to all supplement modal buttons
supplementModalButtons.forEach(button => {
    button.addEventListener("click", (el) => {
        toggleModal(el.currentTarget.dataset.modal);
    });
});

// Add close button event listener
const closeButton = document.querySelector("[data-modal-cta='close']");
if (closeButton) {
    closeButton.addEventListener("click", (el) => {
        toggleModal(el.currentTarget.closest(".c-modal").dataset.modalTarget);
    });
}

// Add click outside modal to close
const modal = document.querySelector("[data-modal-target='supplement']");
if (modal) {
    modal.addEventListener("click", (el) => {
        if (el.target === modal) {
            toggleModal("supplement");
        }
    });
}

// Add escape key to close modal
document.addEventListener("keydown", (el) => {
    if (el.key === "Escape") {
        const openModal = document.querySelector(".c-modal.show");
        if (openModal) {
            toggleModal(openModal.dataset.modalTarget);
        }
    }
});

const toggleModal = (modal) => {
    const modalEl = document.querySelector(`[data-modal-target="${modal}"]`);
    if (modalEl) {
        modalEl.classList.toggle("hidden");
        modalEl.classList.toggle("show");
    }
}
/** END: SUPPLEMENT FACTS POPUP MODAL *********************************/


/** START: COLLAPSIBLE INFO *******************************************/
const accordionWrapperHeader = document.querySelectorAll(".accordion-wrapper .accordion-header");
if (accordionWrapperHeader.length) {
    accordionWrapperHeader.forEach( (headerEl) => { 
      headerEl.addEventListener("click", () => {
        const parentEl = headerEl.closest("li");
        const content = parentEl.querySelector("[data-accordion='content']");

        if (parentEl.classList.contains('active')) {
          parentEl.classList.remove('active');
          content.style.maxHeight = null; // Collapse
        } else {
          parentEl.classList.add('active');
          content.style.maxHeight = `${content.scrollHeight + 32}px`; // Expand to fit content
        }
      })
    })
}
/** END: COLLAPSIBLE INFO *********************************************/


/** START: PRODUCT PANEL **************************************************/
const panels = document.querySelectorAll("[data-product='panel']");

const setOptionDisplay = (panelEl, data) => {
  const listItemEls = panelEl.querySelectorAll("[data-list] > li");
  data.forEach((item, idx) => {
    const row = listItemEls[idx];
    if (!row) return;
    const priceEl = row.querySelector("[data-price]");
    if (priceEl) priceEl.innerText = item.price;
  });
};

const setChooseDisplay = (panelEl, selected) => {
  const chooseText = panelEl.querySelector("[data-choose='text']");
  const choosePrev = panelEl.querySelector("[data-choose='prev']");
  const chooseNew = panelEl.querySelector("[data-choose='new']");
  const chooseSave = panelEl.querySelector("[data-choose='save']");

  if (chooseText) chooseText.innerText = "Total";
  if (choosePrev) choosePrev.innerText = selected?.prevPrice ?? "";
  if (chooseNew) chooseNew.innerText = selected?.newPrice ?? "";
  if (chooseSave) chooseSave.innerText = selected?.discount ?? "";
};

const setProductLink = (panelEl, link) => {
  const cta = panelEl.querySelector("[data-product='cta']");
  if (cta) cta.setAttribute("href", link + newhref);
};

const setSliderActiveForPanel = (panelEl, activeTabEl) => {
  const sliderEl = panelEl.querySelector(".slider");
  if (!sliderEl || !activeTabEl) return;
  sliderEl.style.width = `${activeTabEl.offsetWidth}px`;
  sliderEl.style.transform = `translateX(${activeTabEl.offsetLeft}px)`;
};

var qparam = window.location.search;
qparam = qparam.replace("?", "");
let newhref = "";

// Use the first CTA found to determine if we append ? or &
const firstCta = document.querySelector("[data-product='cta']");
if (firstCta && firstCta.getAttribute("href") && firstCta.getAttribute("href").indexOf('?') >= 0) newhref = "&" + qparam;
else newhref = "?" + qparam;

const optionList = [
  [
    { price: "$33.15", discount: "$395.10", link: "https://go.protaflo.com/products/protaflo-6-pack-sub-ptf-pdp-email", prevPrice: "$594", newPrice: "$198.90" },
    { price: "$41.65", discount: "$172.05", link: "https://go.protaflo.com/products/protaflo-3-pack-sub-ptf-pdp-email", prevPrice: "$297", newPrice: "$124.95" },
    { price: "$50.15", discount: "$43.90", link: "https://go.protaflo.com/products/protaflo-1-pack-sub-ptf-pdp-email", prevPrice: "$99", newPrice: "$55.10" },
  ],
  [
    { price: "$39", discount: "$360", link: "https://go.protaflo.com/products/protaflo-6-pack-ptf-pdp-email", prevPrice: "$594", newPrice: "$234" },
    { price: "$49", discount: "$150", link: "https://go.protaflo.com/products/protaflo-3-pack-ptf-pdp-email", prevPrice: "$297", newPrice: "$147" },
    { price: "$59", discount: "$40", link: "https://go.protaflo.com/products/protaflo-1-pack-ptf-pdp-email", prevPrice: "$99", newPrice: "$63.95" },
  ],
];

let isOneTime = false; // false => tab1 (Subscribe), true => tab2 (One-Time)
let selectedOptionIndex = 0; // 0,1,2 for the three options

const updateAllPanels = () => {
  const optionData = isOneTime ? optionList[1] : optionList[0];
  const selected = optionData[selectedOptionIndex];

  panels.forEach(panel => {
    // Tabs
    const tab1 = panel.querySelector('.tab-button[data-tab="tab1"]');
    const tab2 = panel.querySelector('.tab-button[data-tab="tab2"]');
    panel.classList.toggle('one-time', isOneTime);
    [tab1, tab2].forEach(t => t && t.classList.remove('active'));
    const activeTab = isOneTime ? tab2 : tab1;
    if (activeTab) activeTab.classList.add('active');
    setSliderActiveForPanel(panel, activeTab);

    // Options
    const optionEls = panel.querySelectorAll('[data-option]');
    optionEls.forEach(el => el.classList.remove('active'));
    const activeOption = panel.querySelector(`[data-option="${selectedOptionIndex + 1}"]`);
    if (activeOption) activeOption.classList.add('active');

    // Update supply text and hide/show span tags based on tab selection
    const optionElements = panel.querySelectorAll('[data-option]');
    optionElements.forEach((optionEl, index) => {
      // Find the text element within each option
      const productValueDiv = optionEl.querySelector('.product-value');
      if (productValueDiv) {
        const textEl = productValueDiv.querySelector('.product-label');
        if (textEl) {
          if (isOneTime) {
            // Change text to tubs format
            if (index === 0) textEl.innerHTML = '6-PACK';
            else if (index === 1) textEl.innerHTML = '3-PACK';
            else if (index === 2) textEl.innerHTML = '1-PACK';
          } else {
            // Restore original text
            if (index === 0) textEl.innerHTML = '6-PACK <span class="text-[14px] text-[rgba(45,67,117,0.90)] font-normal">Every 180 Days</span>';
            else if (index === 1) textEl.innerHTML = '3-PACK <span class="text-[14px] text-[rgba(45,67,117,0.90)] font-normal">Every 90 days</span>';
            else if (index === 2) textEl.innerHTML = '1-PACK <span class="text-[14px] text-[rgba(45,67,117,0.90)] font-normal">Every 30 days</span>';
          }
        }
      }
    });

    // Prices and choose area
    setOptionDisplay(panel, optionData);
    setChooseDisplay(panel, selected);
    setProductLink(panel, selected?.link ?? "");
  });
};

// Wire events per panel but drive shared state
panels.forEach(panel => {
  const tabButtons = panel.querySelectorAll('.tab-button');
  tabButtons.forEach(tab => {
    tab.addEventListener('click', () => {
      isOneTime = tab.dataset.tab === 'tab2';
      updateAllPanels();
    });
  });

  const optionEls = panel.querySelectorAll('[data-option]');
  optionEls.forEach(opt => {
    opt.addEventListener('click', () => {
      const idx = Number(opt.dataset.option) - 1;
      if (!isNaN(idx)) selectedOptionIndex = idx;
      updateAllPanels();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  updateAllPanels();
});
/** END: PRODUCT PANEL **************************************************/


/** START: WATCH NOW POPUP MODAL *************************************/
const thumbnail = document.getElementById('thumbnail');
const modalv = document.getElementById('videoModal');
const closeModal = document.getElementById('closeModal');
const video = document.getElementById('modalVideo');

// Open modal and play video
thumbnail.addEventListener('click', () => {
    modalv.classList.remove('hidden');
    modalv.classList.add('flex');
    video.play();
});

// Close modal and pause video
closeModal.addEventListener('click', () => {
    modalv.classList.add('hidden');
    modalv.classList.remove('flex');
    video.pause();
    video.currentTime = 0; // reset video
});

// Close modal when clicking outside video
modalv.addEventListener('click', (e) => {
    if (e.target === modalv) {
        modalv.classList.add('hidden');
        modalv.classList.remove('flex');
        video.pause();
        video.currentTime = 0;
    }
});
/** END: WATCH NOW POPUP MODAL ***************************************/



/** START: PANEL PARALLAX ***********************************************/

/** END: PANEL PARALLAX *************************************************/

// Get the current year dynamically
const dateList = document.querySelectorAll("#currentYear");
for (let i = 0; i < dateList.length; i++) {
    dateList[i].textContent = new Date().getFullYear();
}